import React, { useRef } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Image,
  Box,
  Divider,
  Card,
  CardBody,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import Slideshow from "./Slideshow";

export default function Interfaces() {
  return (
    <Flex pt="10vh" justifyContent={"center"} flexDir={"column"}>
      <Flex
        py="1rem"
        alignItems={"center"}
        justifyContent={"space-evenly"}
        px={{ base: 10, md: 20 }}
      >
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "40%" }}
          src={"/images/uiux_images/laundry.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
        <Flex flexDir={"column"} w="40%">
          <Text variant={"tinyHeader"} my="1rem">
            Interfaces: Brown University Washing Machines
          </Text>
          <Text variant={"subtitle"}>
            Interfaces, defined as a point of interaction between a user and the
            object they are using, can be found everywhere – from soda
            dispensers to web browsers to laundry machines. To analyze what
            makes an ordinary interface successful or not, I had to step into
            the shoes of both a user and a UX designer. I observed users
            interacting with Brown University’s standard washing machines in
            order to gain a better understanding of how students interact with
            the machine interface, what users feel and think when interacting
            with the interface, and how the interface can be improved to enhance
            the user experiences.
          </Text>
        </Flex>
      </Flex>
      <Flex
        py="2rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
        bg="#655899"
      >
        <Text
          variant={"subUIHeader"}
          textAlign={"center"}
          color="white"
          py="1rem"
        >
          1. Pros & Cons
        </Text>
        <Box
          borderRadius={".5rem"}
          bg="white"
          p="1rem"
          w="50%"
          my="1rem"
          display={"flex"}
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            Upon observing and interviewing various users interacting with the
            washing machines in the basement of my dorm, I came to the following
            observations:
          </Text>
        </Box>
        <Text variant={"subtitle"} w="30%" color="white" ml="2rem">
          <ul>
            <li>
              Brown washing machines are one of the cheapest and most convenient
              ways to wash clothes for students
            </li>
            <li> The machines are intuitive and simple to use</li>
            <li> The holding capacity of each machine is unclear</li>
            <li>
              The sticker labels on each machine is helpful, but not very
              explicit
            </li>
            <li> Students must keep track of their own cycle times </li>
            <li>
              Once the machine begins, there is no way to end the cycle
              prematurely
            </li>
            <li> The machine does not seem to be wheelchair accessible</li>
          </ul>
        </Text>
      </Flex>
      <Flex
        py="1rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
        bg="#9597CA"
      >
        <Text
          variant={"subUIHeader"}
          textAlign={"center"}
          color="white"
          py="1rem"
        >
          2. Who uses these machines?
        </Text>
        <Box
          borderRadius={".5rem"}
          bg="white"
          p="1rem"
          w="50%"
          display={"flex"}
          my="1rem"
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            After gathering my data, I drew up two “personas”, or characters,
            that embodied a certain set of traits I observed in each user that
            interacted with the machine. Each persona is divided into Think,
            Feel, Say, and Do categories, which predict and summarize their
            state of being before, during, and after interaction with the
            machine.
          </Text>
        </Box>
        <Text variant={"subtitle"} w="40%" color="white">
          The first persona is Forgetful Francis, who often forgets small
          details such as putting in soap before starting the washing machine
          and setting a timer to remind herself when the cycle ends.
        </Text>
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "40%" }}
          src={"/images/uiux_images/forgetful francis.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
        <Text variant={"subtitle"} w="40%" color="white">
          The second persona is Hurried Harold, a student in a rush to prepare
          for his interview. As a result, he shows more carelessness and
          aggressiveness when using the laundry machines, highlighting some of
          the actions that the washing machines allow that may act as a source
          of distress for students.
        </Text>
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "40%" }}
          src={"/images/uiux_images/hurried harold.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
      </Flex>
      <Flex
        py="2rem"
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
      >
        <Text variant={"subUIHeader"} color="#655899" py="1rem">
          3. Storyboarding
        </Text>
        <Text variant={"subtitle"} w="40%">
          Finally, I sketched out a storyboard of a beginning-to-end interaction
          with the washing machine through the perspective of someone like
          Hurried Harold.
        </Text>
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "40%" }}
          src={"/images/uiux_images/storyboard.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
      </Flex>
    </Flex>
  );
}
